import React from 'react';
import 'twin.macro';
import { navigate } from 'gatsby';

import { GraphQLClient, gql } from 'graphql-request';
import { Container, Heading, Subtitle } from '../atoms';
import SanityImage from '../global/SanityImage';
import BrochureForm from './BrochureForm';
import config from '../../utils/config';

const client = new GraphQLClient(config.apiUrl, {
  timeout: 60000,
});

const contactUsMutation = gql`
  mutation contact($input: ContactInput) {
    contact(input: $input) {
      status
      message
    }
  }
`;

const BrochureBlock = ({ image, title, description, brochureFile }) => {
  const pdf = brochureFile && brochureFile.asset?.url;
  const handleSubmit = async (formData) => {
    const variables = { input: formData };

    await client
      .request(contactUsMutation, variables)
      .then((data2) => {
        setTimeout(() => {
          if (data2) {
            window.open(pdf);
            navigate('/thank-you/');
          }
        }, 3000);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return (
    <Container tw="bg-slate">
      <div tw="py-10 grid grid-cols-1  md:grid-cols-2 justify-center items-center">
        {image && image.asset && <SanityImage gatsbyImageId={image.asset.id} />}
        <div tw="p-6 md:p-14 bg-white">
          <div tw="flex flex-col justify-center">
            <div tw="px-6 py-3">
              <div tw="flex justify-between my-4">
                <div>
                  <Heading tw="font-bold text-xl mb-2">{title}</Heading>
                  <div tw="border mb-4 border-black" />
                </div>
              </div>
              <Subtitle>{description}</Subtitle>
              <BrochureForm onSubmit={(val) => handleSubmit(val)} />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BrochureBlock;
